import React, { useContext, useEffect } from 'react';
import AuthContext, { CacheContext } from '../contexts';
import { useNavigate } from 'react-router-dom';

import '../styles/home.css';
import '../styles/home-plaque.css';
import PartyCard from './PartyCard';


const Home = () => {
    const { user } = useContext(AuthContext);
    const { setActiveParty } = useContext(CacheContext);
    const navigate = useNavigate();
   
    useEffect(() => {
        setActiveParty(null);
    },[]);

    // Only render when user data is loaded
    if (!user) {
        return (
            <div className="App">
                <header className="App-header">
                    <div className="loading-spinner-container">
                        <div className="loading-spinner gold"></div>
                    </div>
                </header>
            </div>
        );
    }

    const hasParties = user?.partyIds && user.partyIds.length > 0;

    return (
        <div className="App">
            <header className="App-header">
                <div className="welcome-card">
                    <h1>Welcome {user?.firstName}!</h1>
                </div>
                
                <div className="section-title-card">
                    <h2>This Year&apos;s Parties</h2>
                </div>
                
                {
                    hasParties
                    ?
                        user.partyIds.map(partyId => {
                            return (<PartyCard partyId={partyId} key={partyId} />
                            )
                        })

                    :
                        <div className="no-parties-container">
                            <p>No Current Parties</p>
                            <button className="btn btn-primary create-party-btn" onClick={() => navigate('/party/create')}>
                                Create New Party
                            </button>
                        </div>   
                
                }

            </header>
        </div>
    );
};

export default Home;
